import React, { useMemo, useContext, memo } from 'react';
import { Link } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';
import { translations } from "../locales/translations_header_footer"; // Import translations
import { useConsent } from '../context/ConsentContext';


const Footer = () => {
  const { language } = useContext(GlobalContext);
  const t = useMemo(() => translations[language || "fr"].footer, [language]);
  const { openPanel } = useConsent();

  return (
    <footer className="ost-topbar text-center py-4 w-full">
      <nav aria-label={t.links.faq} className="flex flex-wrap justify-center gap-x-5 gap-y-1 mb-2 text-sm font-semibold">
        <Link to="/faq" className="text-[var(--text-muted)] hover:underline hover:text-orange-600">{t.links.faq}</Link>
        <Link to="/privacy" className="text-[var(--text-muted)] hover:underline hover:text-orange-600">{t.links.privacy}</Link>
        <Link to="/terms" className="text-[var(--text-muted)] hover:underline hover:text-orange-600">{t.links.terms}</Link>
        <Link to="/contact" className="text-[var(--text-muted)] hover:underline hover:text-orange-600">{t.links.contact}</Link>
        <button
          type="button"
          onClick={openPanel}
          className="text-[var(--text-muted)] hover:underline hover:text-orange-600"
        >
          {t.links.cookies}
        </button>
      </nav>
      <p className="text-sm text-[var(--text-muted)]">
        <a href="https://www.linkedin.com/in/rdrihmia/" target="_" className="hover:underline hover:text-orange-600 font-semibold">{t.poweredBy} </a>
      </p>
    </footer>
  );
};

export default memo(Footer);
